import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { SafetyFeaturesEntity } from 'client/data/models/editorial-review';

export function SafetyFeatures({ modelName, safetyFeatures, isUsed }) {
  return (
    <Fragment>
      <p className="mb-1_5 text-start size-16">
        {isUsed ? `Our experts like the ${modelName} models:` : `Our experts’ favorite ${modelName} safety features:`}
      </p>
      <dl className="mb-0">
        {safetyFeatures.map(({ title, description }) => (
          <Fragment key={title}>
            <dt className="heading-5">{title}</dt>
            <dd className="mb-1_5">{description}</dd>
          </Fragment>
        ))}
      </dl>
    </Fragment>
  );
}

SafetyFeatures.propTypes = {
  modelName: PropTypes.string.isRequired,
  safetyFeatures: SafetyFeaturesEntity.isRequired,
  isUsed: PropTypes.bool,
};

SafetyFeatures.defaultProps = {
  isUsed: false,
};
